/* tslint:disable:max-line-length */
/* tslint:disable:no-trailing-whitespace */
/* tslint:disable:eofline */
import * as React from 'react';
import pure from 'recompose/pure';

class CountryFlagLtIcon extends React.Component<{style: any}> {
    render() {
        return (
            <svg  width={24} height={24} viewBox="0 0 640 480" {...this.props}>
              <g fillRule="evenodd" strokeWidth="1pt" transform="scale(.64143 .96773)">
                <rect width="1063" height="708.7" fill="#006a44" rx="0" ry="0" transform="scale(.93865 .69686)"/>
                <rect width="1063" height="236.2" y="475.6" fill="#c1272d" rx="0" ry="0" transform="scale(.93865 .69686)"/>
                <path fill="#fdb913" d="M0 0h997.8v164.6H0z"/>
              </g>
            </svg>
        );
    }
}

const PureIcon = pure(CountryFlagLtIcon);
PureIcon.displayName = 'CountryFlagLtIcon';
export default PureIcon;
